export const STORAGE_PREFIX = 'flight-center-web-app-';
